import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import f125 from "./components/f-125";
import f250 from "./components/f-250";
import f500 from "./components/f-500";
import f1000 from "./components/f-1000";
import f2000 from "./components/f-2000";
import f4000 from "./components/f-4000";

const principle: Slide = {
  title: "",
  description:
    "Please select a diffuser shape and a frequency to show the simulation result of the reflected sound pressure created by the diffuser’s geometry. Only the reflected (scattered) sound field is shown here, not the direct sound emitted by the sound source.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "dropdown",
          options: {
            label: "Frequency",
          },
          items: [
            { name: "125 Hz" },
            { name: "250 Hz" },
            { name: "500 Hz" },
            { name: "1000 Hz" },
            { name: "2000 Hz" },
            { name: "4000 Hz" },
          ],
        },
        {
          type: "dropdown",
          options: {
            label: "Diffuser shape",
          },
          items: [
            { name: "flat panel 3m" },
            { name: "flat panel 1m" },
            { name: "convex" },
            { name: "squares 10 cm (spaced 10 cm)" },
            { name: "squares 10 cm (spaced 30 cm)" },
            { name: "squares 20 cm (spaced 20 cm)" },
            { name: "QRD (order N=7)" },
            { name: "random pattern 3 cm" },
            { name: "random pattern 10 cm" },
          ],
        },
      ],
      extraContent: [
        [[], [], [], [], [], [], [], [], []],
        [[], [], [], [], [], [], [], [], []],
        [[], [], [], [], [], [], [], [], []],
        [[], [], [], [], [], [], [], [], []],
        [[], [], [], [], [], [], [], [], []],
        [[], [], [], [], [], [], [], [], []],
      ],
      components: [f125, f250, f500, f1000, f2000, f4000],
    },
  },
};

export default principle;
